import { Author } from '../api/Author';
import { supabase } from '../api/apiService';

interface SubscribeToAuthenticatedAuthorOptions {
  authorId: number;
  setAuthor: React.Dispatch<React.SetStateAction<Author | null>>;
}

const getAuthenticatedAuthorFilter = (authorId: number): string => `id=eq.${authorId}`;

export const subscribeToAuthenticatedAuthor = ({
  authorId,
  setAuthor,
}: SubscribeToAuthenticatedAuthorOptions): (() => void) => {
  const channel = supabase
    .channel(`auth_author_update:${authorId}`)
    .on<Author>(
      'postgres_changes',
      { event: 'UPDATE', schema: 'public', table: 'authors', filter: getAuthenticatedAuthorFilter(authorId) },
      (payload) => {
        if (payload.new) {
          setAuthor(payload.new as Author);
        }
      }
    );

  channel.subscribe();

  return () => {
    void supabase.removeChannel(channel);
  };
};
